import axios from "axios";

const initialState = { loading: false, error: null };

export const FETCH_DATA_REPORT_LIST_REQUEST =
  "data-report/FETCH_DATA_REPORT_LIST_REQUEST";
export const FETCH_DATA_REPORT_LIST_SUCCESS =
  "data-report/FETCH_DATA_REPORT_LIST_SUCCESS";
export const FETCH_DATA_REPORT_LIST_FAILURE =
  "data-report/FETCH_DATA_REPORT_LIST_FAILURE";

export default function dataReportList(state = initialState, action = {}) {
  switch (action?.type) {
    case FETCH_DATA_REPORT_LIST_REQUEST:
      return { ...state, loading: true };
    case FETCH_DATA_REPORT_LIST_SUCCESS:
      return { ...state, loading: false, error: null, reports: action.payload };
    case FETCH_DATA_REPORT_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export const fetchDataReportListRequest = () => ({
  type: FETCH_DATA_REPORT_LIST_REQUEST
});

export const fetchDataReportListSuccess = reports => ({
  type: FETCH_DATA_REPORT_LIST_SUCCESS,
  payload: reports
});

export const fetchDataReportListFailure = error => ({
  type: FETCH_DATA_REPORT_LIST_FAILURE,
  payload: error
});

export const fetchDataReportList = () => async (dispatch, getState) => {
  const {
    paths: { api }
  } = getState();
  dispatch(fetchDataReportListRequest());
  try {
    const { data } = await axios.get(`${api}/personaluser/dataReports`);
    dispatch(fetchDataReportListSuccess(data));
  } catch (error) {
    dispatch(fetchDataReportListFailure(error));
  }
};

export const getDataReports = state =>
  state.dataReport?.dataReportList?.reports || [];

export const fetchDataReportListLoading = state =>
  state.dataReport.dataReportList.loading || false;

export const hasPendingDataReports = state =>
  getDataReports(state).some(({ status }) => status === "pending");

export const hasAnyDataReports = state => Boolean(getDataReports(state).length);

export const getDataReportsError = state =>
  state.dataReport?.dataReportList?.error;
